export default __webpack_public_path__ + "static/media/menu.b731d4a9.svg";